import React, { forwardRef, useContext, useEffect } from 'react';
import classNames from 'classnames';

import { Comp, Flexbox, FocusWithinGroupContext } from '@redsift/design-system';
import { MenuButtonContentMenuProps } from './types';

const COMPONENT_NAME = 'MenuButtonContentMenu';
const CLASSNAME = 'redsift-menu-button-content-menu';

/**
 * The MenuButtonContentMenu component.
 */
export const MenuButtonContentMenu: Comp<MenuButtonContentMenuProps, HTMLDivElement> = forwardRef((props, ref) => {
  const { children, className, ...forwardedProps } = props;

  const focusContext = useContext(FocusWithinGroupContext);

  useEffect(() => {
    if (focusContext && focusContext.state.delayedAction && focusContext.state.tabStops.length) {
      focusContext.dispatch(focusContext.state.delayedAction);
    }
  }, [focusContext.state.delayedAction, focusContext.state.tabStops.length]);

  return (
    <Flexbox
      flexDirection="column"
      gap="8px"
      margin="8px 0px"
      width="100%"
      className={classNames(MenuButtonContentMenu.className, className)}
      role="menu"
      as="ul"
      {...forwardedProps}
      ref={ref}
    >
      {children}
    </Flexbox>
  );
});
MenuButtonContentMenu.className = CLASSNAME;
MenuButtonContentMenu.displayName = COMPONENT_NAME;
